import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  background-color: #e5f5f2;
  border-radius: 20px;
  .main-div {
    background-color: white;
    border-radius: 20px;
  }
`;

export const EvaluationSection = styled.div`
  background-color: white;
  border-radius: 20px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;

  @media screen and (min-width: 768px) {
    padding: 0 15%;
    max-width: 1050px; /* Removed quotes - was causing the issue */
    border-radius: 20px;
  }
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
`;

export const SectionHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;

  @media (min-width: 768px) {
    padding: 20px;
  }
`;

export const ContentSection = styled.div`
  padding: 20px 16px;

  @media (min-width: 768px) {
    padding: 24px 20px;
  }
`;

export const DietTitle = styled.h3`
  color: #142c1f;
  margin: 0 0 16px;
  font-size: 16px;
`;

export const DietDescription = styled.div`
  text-align: left;
  margin-top: 15px;
  font-size: 16px;
  line-height: 1.5;
  color: #4f4f4f;

  ul {
    padding-left: 20px;
    margin: 10px 0;
  }

  li {
    margin-bottom: 8px;
  }
`;

export const DietFeaturesTitle = styled.p`
  color: #44554c;
  margin: 0 0 4px;
`;

export const FeaturesList = styled.ul`
  padding-left: 20px;
  margin: 0 0 24px;

  li {
    color: #44554c;
    margin-bottom: 8px;
    line-height: 1.5;
  }
`;

export const BenefitsSection = styled.div`
  border-top: ${(props) => (props.noBorder ? "none" : "1px solid #e2e4e9")};
  padding: 20px 0px;
  padding-top: 24px;
  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const BenefitsTitle = styled.h3`
  color: #142c1f;
  margin: -10px 0 20px;
  font-size: 16px;
  @media screen and (min-width: 768px) {
    padding-left: 20px;
  }
`;

export const BenefitCard = styled.div`
  padding: 8px;
  background: #ffffff;
  border-radius: 12px;
  height: 100%;
  margin-bottom: 16px;
  border: 1px solid #d0d5dd;
`;

export const BenefitHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

export const BenefitCircle = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #2ecf96;
  margin-right: 6px;
  flex-shrink: 0;
  box-shadow: 0px 1px 2px #1018280d;
  border: 2px solid #ededed;
  border-radius: 17px;
`;

export const BenefitTitle = styled.h3`
  color: #142c1f;
  margin: 0;
  font-size: 16px;
`;

export const BenefitDescription = styled.p`
  color: #44554c;
  line-height: 1.5;
  margin: 0;
  padding-left: 30px;
`;

export const SliderContainer = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
    position: relative;
    width: 100%;
    margin-bottom: 20px;

    .slick-slide {
      padding: 0 5px;
    }

    .slick-track {
      display: flex;
      align-items: stretch;
    }
  }
`;

export const SliderWrapper = styled.div`
  display: flex;
  width: 100%;
  will-change: transform;
`;

export const PaginationDots = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

export const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? "#2ECF96" : "#A5B5AF")};
  margin: 0 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
`;
export const DesktopView = styled.div`
  display: none;
  @media screen and (min-width: 768px) {
    display: block;
  }
`;
export const Tile = styled.div`
  border: 1px solid #d0d5dd;
  border-radius: 16px;
  display: flex;
  gap: 10px;
  padding: 10px;
  margin-bottom: 15px;
`;
export const ContentDiv = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
  width: 100%;
  h3 {
    text-align: left !important;
  }
  p {
    text-align: left !important;
    margin-bottom: 0 !important;
  }
`;
export const Circle = styled.div`
  width: 33px;
  height: 30px;
  background-color: #2ecf96;
  box-shadow: 0px 1px 2px #1018280d;
  border: 2px solid #ededed;
  border-radius: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    color: white;
    font-size: 14px;
    margin: 0;
    font-weight: bold;
  }
`;

export const Description = styled.p`
  color: #44554c;
  margin: 0 0 16px;
  text-align: center;
`;

export const DesktopSliderContainer = styled.div`
  width: 100%;
  margin: 20px auto;
  box-sizing: border-box;
  overflow: hidden; /* Add overflow handling */

  .slick-slide {
    padding: 0 10px;
    width: 100% !important; /* Force width constraint */
    box-sizing: border-box;
  }

  .slick-list {
    overflow: hidden;
    width: 100%;
  }

  .slick-track {
    display: flex;
    align-items: stretch;
    width: 100% !important; /* Force width constraint */
  }

  .slick-prev,
  .slick-next {
    z-index: 1;
    &:before {
      color: #2ecf96;
    }
  }

  .slick-prev {
    left: -25px;
  }

  .slick-next {
    right: -25px;
  }
`;

export const RegularTitle = styled.h3`
  color: #142c1f;
  font-size: 16px;
`;

export const LoadingText = styled.div`
  padding: 20px;
  text-align: center;
  color: #666;
  font-style: italic;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin: 20px 0;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
`;

export const DietBulletItem = styled.div`
  display: flex;
  padding-left: 20px;
  margin-bottom: 5px;
  text-align: left;
`;
